import { UPDATE_CHAT_STATE } from '../../constants/action-types';

export const updateChatState = chatState => {
  return {
    type: UPDATE_CHAT_STATE,
    payload: {
      chatState
    }
  };
};